/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_Play_PauseInputs */

const en_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play/Pause`)
};

const fr_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture/Pause`)
};

const de_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiedergabe/Pause`)
};

const it_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riproduci/Pausa`)
};

const ru_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Воспроизведение/Пауза`)
};

const es_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproducir/Pausa`)
};

const zh_cn2_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`播放/暂停`)
};

const ja_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再生/一時停止`)
};

const hi_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चलाएँ/रोकें`)
};

const pt_pt2_options_pedal_action_play_pause = /** @type {(inputs: Options_Pedal_Action_Play_PauseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproduzir/Pausar`)
};

/**
* | output |
* | --- |
* | "Play/Pause" |
*
* @param {Options_Pedal_Action_Play_PauseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_play_pause = /** @type {((inputs?: Options_Pedal_Action_Play_PauseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_Play_PauseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_pedal_action_play_pause(inputs)
	if (locale === "de") return de_options_pedal_action_play_pause(inputs)
	if (locale === "it") return it_options_pedal_action_play_pause(inputs)
	if (locale === "ru") return ru_options_pedal_action_play_pause(inputs)
	if (locale === "es") return es_options_pedal_action_play_pause(inputs)
	if (locale === "zh-CN") return zh_cn2_options_pedal_action_play_pause(inputs)
	if (locale === "ja") return ja_options_pedal_action_play_pause(inputs)
	if (locale === "hi") return hi_options_pedal_action_play_pause(inputs)
	if (locale === "pt-PT") return pt_pt2_options_pedal_action_play_pause(inputs)
	return en_options_pedal_action_play_pause(inputs)
});